import './style.scss'
import { Button, message, Modal } from 'antd'
import { FC, memo, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import * as Api from '@/api/home'

interface IProps {
  open: boolean
  onSuccess?: () => void
  onCancel?: () => void
}

const ConvertCouponModal: FC<IProps> = (props) => {
  const { t: translate } = useTranslation(['convert_coupon_modal'])
  const { open, onSuccess, onCancel } = props
  const [convertList, setConvertList] = useState<any[]>([])
  const [checkOption, setCheckOption] = useState<any>({})

  useEffect(() => {
    if (open) {
      getList()
    }
  }, [open])

  const getList = async () => {
    const res = await Api.getCouponOptions()
    setConvertList(res?.list || [])
    setCheckOption(res?.list?.[0])
  }

  const toConvert = async () => {
    if (!checkOption.id) {
      message.warning(translate('convert_coupon_modal.select_option_warning'))
    }
    await Api.convertCoupon(checkOption.id)
    onSuccess?.()
  }

  return (
    <>
      <Modal
        title={translate('convert_coupon_modal.modal_title')}
        maskClosable={false}
        className={`title-modal coupon-convert-modal`}
        onCancel={onCancel}
        width={600}
        open={open}
        footer={null}
      >
        <div className="coupon-convert-content">
          <div className="list">
            {convertList?.map((o) => (
              <div
                className={`list-item ${checkOption?.id === o.id ? 'actived' : ''}`}
                key={o.id}
                onClick={() => setCheckOption(o)}
              >
                <div className="score">{o.title}</div>
                <div className="price">
                  <div className="discount-price">
                    <label className="gradient">{(o.deduct_amount || 0) / 100}</label>
                    <label className="unit gradient">{translate('convert_coupon_modal.yuan')}</label>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="desc">
            <div className="desc-title">{translate('convert_coupon_modal.exchange_instructions')}</div>
            <div className="desc-list">
              <div className="desc-list_item">
                {translate('convert_coupon_modal.instruction_1', { amount: (checkOption?.deduct_amount || 0) / 100 })}
              </div>
              <div className="desc-list_item">{translate('convert_coupon_modal.instruction_2')}</div>
              <div className="desc-list_item">
                {translate('convert_coupon_modal.instruction_3')}
                <label className="red">{checkOption?.expire_days}</label>
                {translate('convert_coupon_modal.instruction_3_d')}
              </div>
            </div>
          </div>

          <div className="pay">
            <div className="name">{translate('convert_coupon_modal.points_consumed')}</div>
            <div className="credits">
              <label className="gradient"> {checkOption?.credits}</label>
              <label className="unit gradient">{translate('convert_coupon_modal.points')}</label>
            </div>
          </div>

          <div className="btn">
            <Button type="primary" onClick={toConvert}>
              {translate('convert_coupon_modal.exchange_now')}
            </Button>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default memo(ConvertCouponModal)
